//const Home = () => import('~/pages/frontend/home').then(m => m.default || m)
//const OurProduct = () => import('~/pages/frontend/product').then(m => m.default || m)
//const AboutUs = () => import('~/pages/frontend/about').then(m => m.default || m)

const Dashboard = () => import('~/pages/backend/dashboard').then(m => m.default || m)
const User = () => import('~/pages/backend/user').then(m => m.default || m)
const News = () => import('~/pages/backend/news').then(m => m.default || m)
const Report = () => import('~/pages/backend/report').then(m => m.default || m)
const Category = () => import('~/pages/backend/category').then(m => m.default || m)
const Product = () => import('~/pages/backend/product').then(m => m.default || m)
const Machine = () => import('~/pages/backend/machine').then(m => m.default || m)
const Transaction = () => import('~/pages/backend/transaction').then(m => m.default || m)

const Login = () => import('~/pages/backend/login').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

export default [
  { path: '/', name: 'home', redirect: '/dashboard' },
  /* { path: '/our-product', name: 'our-product', component: OurProduct },
  { path: '/about-us', name: 'about-us', component: AboutUs }, */

  { path: '/dashboard', name: 'dashboard', component: Dashboard },
  { path: '/user', name: 'user', component: User },
  { path: '/news', name: 'news', component: News },
  { path: '/report', name: 'report', component: Report },
  //Product Management
  { path: '/category', name: 'category', component: Category },
  { path: '/product', name: 'product', component: Product },
  //Machine Management
  { path: '/machine', name: 'machine', component: Machine },
  { path: '/transaction', name: 'transaction', component: Transaction },

  { path: '/login', name: 'login', component: Login },

  { path: '*', component: NotFound }
]


// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js